module.exports = __webpack_public_path__ + "static/media/micro.6cc46d55.svg";